import { Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { Design } from 'src/app/interfaces/design';
import { DesignCategory } from 'src/app/interfaces/design-category';
import { assert } from 'src/app/utils/assert.util';

@Injectable({
  providedIn: 'root'
})
export class DesignsProviderService extends APIProviderService<Design> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Designs`;
  }

  async getCategories(retailerIframeID: string | null) {
    const url = new URL(`${this.baseURL}${this.attributeURL}/categories/`);
    if (retailerIframeID) {
      url.searchParams.set('retailerIframeID', retailerIframeID);
    }
    const categories = await this.webProvider.get<DesignCategory[]>(url.href);
    assert(categories, 'Categories response was null');
    return categories;
  }
}
